module.exports = __webpack_public_path__ + "static/media/premium-star.f57e1089.svg";